import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=a90560b0&scoped=true&"
import script from "./Project.vue?vue&type=script&lang=js&"
export * from "./Project.vue?vue&type=script&lang=js&"
import style0 from "./Project.vue?vue&type=style&index=0&id=a90560b0&prod&lang=less&scoped=true&"
import style1 from "./Project.vue?vue&type=style&index=1&id=a90560b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90560b0",
  null
  
)

export default component.exports